import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "./slice/authSlice";
import gameStateReducer from "./slice/gameStateSlice";
import cardSliceReducer from "./slice/cardSlice";
import cameraStatusReducer from "./slice/cameraStatusSlice";
import thunk from "redux-thunk";

const rootReducer = combineReducers({
  auth: authReducer,
  gameState: gameStateReducer,
  card: cardSliceReducer,
  cameraStatus: cameraStatusReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: [thunk],
});
